import { useEffect, useState, useCallback } from 'react'
import { useKassaSocket } from '@/lib/kassaSocket'
import { Link } from 'react-router-dom'
import { ShoppingBag, Trophy, ArrowRight, Wallet } from 'lucide-react'
import { kassaAPI } from '@/lib/api'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'

export default function KassaHomeWidget() {
  const [leaderboard, setLeaderboard] = useState([])
  const [loading, setLoading] = useState(true)
  const [reachable, setReachable] = useState(true)

  const reload = useCallback(() => {
    kassaAPI.getLeaderboard()
      .then(res => setLeaderboard((res.data.leaderboard || []).slice(0, 5)))
      .catch(() => setReachable(false))
      .finally(() => setLoading(false))
  }, [])
  useEffect(() => { reload() }, [reload])
  useKassaSocket(() => reload())

  if (loading || !reachable) return null

  return (
    <Card className="border-neon-blue/30 bg-gradient-to-br from-card to-neon-blue/5">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <ShoppingBag className="h-5 w-5 text-neon-blue" />
          <CardTitle className="text-lg text-neon-blue">Bar & Bestellen</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <Button asChild className="w-full">
          <Link to="/bestellen">
            <ShoppingBag className="h-4 w-4 mr-2" /> Naar Bestellen <ArrowRight className="ml-auto h-4 w-4" />
          </Link>
        </Button>
        <Button asChild variant="outline" className="w-full">
          <Link to="/kassa/mij">
            <Wallet className="h-4 w-4 mr-2" /> Mijn saldo <ArrowRight className="ml-auto h-4 w-4" />
          </Link>
        </Button>

        <div className="pt-3 border-t border-border">
          <div className="flex items-center gap-2 mb-2">
            <Trophy className="h-4 w-4 text-neon-yellow" />
            <span className="text-xs uppercase tracking-wider text-muted-foreground">Top-drinkers</span>
          </div>
          {leaderboard.length > 0 ? (
            <ol className="space-y-1 text-sm">
              {leaderboard.map((entry, idx) => {
                const name = entry.customer?.name || entry.name || entry.customer_name || '—'
                const orders = entry.orders ?? entry.order_count ?? entry.total ?? entry.count ?? 0
                return (
                  <li key={idx} className="flex items-center justify-between">
                    <span className="truncate">
                      <span className="text-muted-foreground mr-2">{entry.position ?? idx + 1}.</span>
                      {name}
                    </span>
                    <Badge variant="outline" className="text-[10px]">{orders}</Badge>
                  </li>
                )
              })}
            </ol>
          ) : (
            <p className="text-xs text-muted-foreground">Nog geen bestellingen dit event.</p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
